/*==============================================================================
TEST ID: [CHS-124] [PDP] Featured 5-Star Reviews [ALL]
PLATFORM: Shoplift
DATE: 2026-07

GOAL:
This test will select a 5 Star review to be featured under the Gallery Image to highlight positive customer feedback.
The selection of which 5 star review is random but has certain criteria to select which review to display as featured.

KEY INSIGHT:

BEHAVIOR:
- Only runs on PDPs that contain Reviews
- Small delay since Review section has to load on the page first
- No featured review is shown if there are no 5 star reviews to pull from
- Ingnores missing/empty reviews or has anonymous author
- Stronger bias toward reviews with longer copy
==============================================================================*/

// Initialize test
async function initTestCHS_124() {

  /* ===========================
     CONFIG
     =========================== */
  const TEST_ID = 'CHS124';
  const HYPOTHESIS_ID = '019eff95-c629-7737-a1b3-e18c2acd1f99';
  var STYLE_ID = TEST_ID + '-CSS';
  var MAX_WAIT_MS = 15000;
  var POLL_INTERVAL_MS = 300;

  /* ===========================
     HELPERS
     =========================== */

  function getText(el) {
    if (!el) return '';
    return String(el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isValidFiveStar(item) {
    var authorEl = item.querySelector('.yotpo-reviewer-name-text');
    var author = authorEl ? authorEl.textContent.trim() : '';
    if (!author || author.toLowerCase() === 'anonymous') return false;

    var ratingEl = item.querySelector('.yotpo-review-star-rating[aria-label]');
    if (!ratingEl) return false;

    return /5 out of 5/.test(ratingEl.getAttribute('aria-label'));
  }

  function extractReview(item) {
    if (!isValidFiveStar(item)) return null;

    var titleEl = item.querySelector('.yotpo-review-title');
    var bodyEl = item.querySelector('.yotpo-read-more-text');
    if (!bodyEl) return null;

    return {
      author: item.querySelector('.yotpo-reviewer-name-text').textContent.trim(),
      title: titleEl ? getText(titleEl) : '',
      body: getText(bodyEl)
    };
  }

  function getScore(r) {
    var base = (r.title.length * 1) + (r.body.length * 2.5);
    if (base < 50) base *= 0.25;
    return Math.pow(Math.max(1, base), 2);
  }

  function pickWeighted(arr) {
    var total = 0;
    var scores = [];

    for (var i = 0; i < arr.length; i++) {
      scores[i] = getScore(arr[i]);
      total += scores[i];
    }

    var rand = Math.random() * total;
    var acc = 0;

    for (var j = 0; j < arr.length; j++) {
      acc += scores[j];
      if (rand <= acc) return arr[j];
    }

    return arr[0];
  }

  /* ===========================
     INIT (TARGETING + READINESS)
     =========================== */

  /* ✅ PDP targeting */
  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  var startTime = Date.now();
  var timer = setInterval(async function () {

    var items = document.querySelectorAll('li.yotpo-reviews-item');

    /* ✅ wait for Yotpo */
    if (!items.length && Date.now() - startTime < MAX_WAIT_MS) return;

    clearInterval(timer);

    /* ✅ validate usable reviews */
    var reviews = [];

    for (var i = 0; i < items.length; i++) {
      var data = extractReview(items[i]);
      if (data) reviews.push(data);
    }

    if (!reviews.length) return;

    try {
      var variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

      if (!variantResult) {
        console.log(`Showing ${TEST_ID} Control`);
        return;
      }
	  // TEST - Show Variant
      (function () {

        //==========================
        // ONE-RUN GUARD
        //==========================
        if (window[TEST_ID + '_INIT']) return;
        window[TEST_ID + '_INIT'] = true;

        /* ===========================
           CSS INJECTION
           =========================== */
        if (!document.getElementById(STYLE_ID)) {
          var style = document.createElement('style');
          style.id = STYLE_ID;
          style.textContent = `
            #${TEST_ID}-header {
              margin: 40px 0 21px;
              font-size: 16px;
              color: #222;
              font-family: var(--font-body);
              font-weight: 600;
              line-height: 120%;
              letter-spacing: 0.06rem;
              text-transform: uppercase;
            }

            #${TEST_ID} {
              background: #f9f7f2;
              border-radius: 8px;
              padding: 20px;
              margin-bottom: 12px;
              opacity: 0;
              transform: translateY(10px);
              transition: opacity 260ms ease, transform 260ms ease;
            }

            #${TEST_ID}.is-visible {
              opacity: 1;
              transform: translateY(0);
            }

            #${TEST_ID} .ch-hr-meta {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
            }

            #${TEST_ID} .ch-hr-meta-author {
              color: #fff;
              font-weight: 600;
              border: 3px solid #222;
              background-color: #222;
              border-radius: 16px;
              padding: 1px 5px 0 4px;
              font-size: 11px;
            }

            #${TEST_ID} .ch-hr-meta-author i.fa.fa-user-circle {
              font-size: 16px !important;
              vertical-align: text-top;
              padding-right: 3px;
              margin-left: -2px;
              color: #fff;
            }

            #${TEST_ID} .ch-hr-meta span {
              padding-left: 8px;
              font-size: 17px;
            }

            #${TEST_ID} .ch-hr-meta-title {
              font-size: 16px;
              font-weight: 500;
            }

            #${TEST_ID} p {
              margin: 7px 0;
              line-height: 1.5;
              color: #444;
              font-size: 14px;
            }

            #${TEST_ID} .ch-hr-read-more {
              margin-top: 12px;
            }

            #${TEST_ID} .ch-hr-read-more a {
              font-size: 13px;
              text-decoration: underline;
              text-underline-offset: 2px;
              cursor: pointer;
            }

            @media (max-width: 749px) {
              #${TEST_ID}-header { margin: 0px 0px -20px; }
              #${TEST_ID} { margin: 0px 0px -10px; }
            }
          `;
          document.head.appendChild(style);
        }

        /* ===========================
           PLACEMENT
           =========================== */

        var isMobile = window.matchMedia('(max-width: 767px)').matches;

        var placement = isMobile
          ? document.getElementById('product-information-section')
          : document.querySelector('media-gallery');

        if (!placement) return;
		
		/* ✅ Secondary guard (DOM-level) */
        if (document.getElementById(TEST_ID)) return;

        var chosen = pickWeighted(reviews);

        /* ===========================
           BUILD
           =========================== */

        var header = document.createElement('h4');
        header.id = TEST_ID + '-header';
        header.textContent = 'What our customers are saying';

        var container = document.createElement('div');
        container.id = TEST_ID;

        container.innerHTML =
          '<div class="ch-hr-meta">' +
            '<div class="ch-hr-meta-author">' +
              '<i class="fa fa-user-circle" aria-hidden="true"></i>' +
              chosen.author +
            '</div>' +
            '<span>★★★★★</span>' +
          '</div>' +
          (chosen.title ? '<div class="ch-hr-meta-title">' + chosen.title + '</div>' : '') +
          '<p>“' + chosen.body + '”</p>' +
          '<p class="ch-hr-read-more">' +
            '<a href="#" data-scroll-to-yotpo>Read more reviews</a>' +
          '</p>';

        /* ===========================
           RENDER
           =========================== */

        placement.appendChild(header);
        placement.appendChild(container);

        var link = container.querySelector('[data-scroll-to-yotpo]');
        if (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();

            var target = document.getElementById('yotpo-app');
            if (!target) return;

            var offset = 120;
            var y = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          });
        }

        container.offsetWidth;
        container.className += ' is-visible';
		console.log(`Showing ${TEST_ID} Variant`)
      })();

    } catch (error) {
	  // Always fail gracefully - show control experience on error	
      console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }

  }, POLL_INTERVAL_MS);
}

/* Guard Check - Safely Checking for Shoplift */
function whenShopliftReady(cb, timeoutMs = 5000) {
  const start = Date.now();

  const tick = setInterval(function () {
    if (window.shoplift) {
      clearInterval(tick);
      cb();
    } else if (Date.now() - start > timeoutMs) {
      clearInterval(tick);
      console.warn('Shoplift not available after ' + timeoutMs + 'ms');
    }
  }, 50);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => whenShopliftReady(initTestCHS_124));
} else {
  whenShopliftReady(initTestCHS_124);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////				

/*==============================================================================
TEST ID: CHS-131B [Cart] Horizontal Checkout CTAs [ALL]
PLATFORM: Shoplift
DATE: 2026-06

GOAL:
Remove `.additional-checkout-buttons--vertical` so Shopify applies native
horizontal layout for Shop Pay / PayPal buttons.

KEY INSIGHT:
Layout is controlled by wrapper class, NOT shadow DOM.
No CSS overrides required.

BEHAVIOR:
- Runs once on load (primary path)
- Observes class attribute as lightweight fallback (future-safe)
==============================================================================*/

// Initialize test
async function initTestCHS_131B() {
    
    // Configuration
    const TEST_ID = 'CHS131B';
    const HYPOTHESIS_ID = '019eff9c-a24c-796f-abef-9a3fec884ff1';
    let variantResult = null;

    try {
        // Check if visitor is in the variant group
        variantResult = await window.shoplift.isHypothesisActive(HYPOTHESIS_ID);

        if (variantResult) {
            
            // TEST - Show Variant
            (function () {

                //==========================
                // ONE-RUN GUARD
                //==========================
                if (window[TEST_ID + '_INIT']) {
                    return;
                }
                window[TEST_ID + '_INIT'] = true;

                //==========================
                // CORE FUNCTION
                //==========================
                function removeVerticalClass() {
                    var el = document.querySelector('.additional-checkout-buttons');

                    if (!el) return;

                    if (el.classList.contains('additional-checkout-buttons--vertical')) {
                        el.classList.remove('additional-checkout-buttons--vertical');
                        console.log(TEST_ID + ' Removed vertical class');
                    }
                }
								
								//==========================
                // EARLY FORCE RUN (NEW FIX)
                //==========================
                removeVerticalClass();

                //==========================
                // WAIT FOR ELEMENT
                //==========================
                function waitForElement(selector, callback) {
                    var attempts = 0;
                    var maxAttempts = 20;

                    var interval = setInterval(function () {
                        var el = document.querySelector(selector);

                        if (el) {
                            clearInterval(interval);
                            callback(el);
                        }

                        attempts = attempts + 1;

                        if (attempts >= maxAttempts) {
                            clearInterval(interval);
                        }

                    }, 150);
                }

                //==========================
                // INIT FUNCTION
                //==========================
                function init() {
                    var el = document.querySelector('.additional-checkout-buttons');

                    if (!el) return;

                    removeVerticalClass();

                    //==========================
                    // LIGHTWEIGHT FALLBACK
                    //==========================                    
										var observer = new MutationObserver(function () {
											setTimeout(function () {
												removeVerticalClass();
											}, 50);
										});


                    observer.observe(el, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                }

                //==========================
                // START (with waitForElement)
                //==========================
                function start() {
                    waitForElement('.additional-checkout-buttons', function () {
                        init();
                    });
                }

                //==========================
                // LOAD HANDLING
                //==========================
                if (document.readyState === 'complete' || document.readyState === 'interactive') {
                    start();
                } else {
                    document.addEventListener('DOMContentLoaded', start);
                }

            })();

            console.log(`Showing ${TEST_ID} Variant`);

        } else {
            console.log(`Showing ${TEST_ID} Control`);
        }

    } catch (error) {
        console.error(`Shoplift test ${TEST_ID} failed:`, error);
    }
}

// Guard Check - Safely Checking for Shoplift
function whenShopliftReady(cb, timeoutMs = 5000) {
    var start = Date.now();

    var tick = setInterval(function () {
        if (window.shoplift) {
            clearInterval(tick);
            cb();
        } else if (Date.now() - start > timeoutMs) {
            clearInterval(tick);
            console.warn('Shoplift not available after ' + timeoutMs + 'ms');
        }
    }, 50);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        whenShopliftReady(initTestCHS_131B);
    });
} else {
    whenShopliftReady(initTestCHS_131B);
}

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////